﻿import $ from "jquery";
import { GuiBase } from "../../GuiBase";


export class GuiDetailMobilAnfallstelle extends GuiBase {

    constructor() {
        super("MobilAnfallstelle");
    }

    override attachEvents() {
        this.log("attacheEvents");

        $("#divAktionList div.erz-list-element").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickAktionElement(e));
        $("#divAdbList div.erz-list-element").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickAdbElement(e));
        $("#AbfallId").on("change", () => this.filter());
        $("#BehaelterId").on("change", () => this.filter());
        $("#Datum").on("change", () => this.filter());
    }

    clickAktionElement(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickAktionElement");
        e.preventDefault();
        const id = $(e.currentTarget).closest("div.erz-list-element").data("id") as string | number;
        const baseUrl = $(e.currentTarget).closest("div.erz-list").data("url-goto") as string;

        const url = `${baseUrl}?id=${id}`;
        this.gotoUrl(url);
    }

    clickAdbElement(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickAdbElement");
        e.preventDefault();

        const adbId = $(e.currentTarget).closest("div.erz-list-element").data("id") as string | number;
        const baseUrl = $(e.currentTarget).closest("div.erz-list").data("url-goto") as string;
        const url = `${baseUrl}?adbId=${adbId}`;

        this.gotoUrl(url);
    }

    filter() {
        const avv = $("#AbfallId").val() as string;
        const behaelterId = $("#BehaelterId").val() as string;
        const datum = $("#Datum").val() as string;

        $("div.erz-list div.erz-list-element[data-avv]").removeClass("d-none");

        if (avv !== "-1") {
            const noMatch = $(`div.erz-list div.erz-list-element[data-avv!='${avv}']`);
            noMatch.addClass("d-none");
        }

        if (behaelterId !== "-1") {
            const noMatch = $("div.erz-list div.erz-list-element[data-behaeltertypid!='" + behaelterId + "']");
            noMatch.addClass("d-none");
        }
        if (datum !== "-1") {
            $("div.erz-list div.erz-list-element[data-avv]").addClass("d-none");

            let match = $("#divAktionList div.erz-list-element[data-wunschtermin='" + datum + "']");
            match.removeClass("d-none");
            match = $("#divAktionList div.erz-list-element[data-geplantam='" + datum + "']");
            match.removeClass("d-none");
        }

        // Anzahl Aktionen
        const totalAktion = $("#divAktionList div.erz-list-element[data-avv]").length;
        const dnoneAktion = $("#divAktionList div.erz-list-element[data-avv].d-none").length;
        $("#countAktion").text(totalAktion - dnoneAktion);

        // Anzahl ADB
        const totalAdb = $("#divAdbList div.erz-list-element[data-avv]").length;
        const dnoneAdb = $("#divAdbList div.erz-list-element[data-avv].d-none").length;
        $("#countAdb").text(totalAdb - dnoneAdb);

    }
}
